module.exports = __webpack_public_path__ + "static/media/logo142.623f7d50.png";